import { Injectable } from "@angular/core";
import { fetchAuthSession} from "aws-amplify/auth";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class TokenService {
  public tokenGG: string = "";
  private tokenReadySubject = new BehaviorSubject<boolean>(false);
  public tokenReady$ = this.tokenReadySubject.asObservable();

  constructor() {
    this.refreshToken();
  }

  async refreshToken(): Promise<string> {
    console.log('🔄 Refrescando token...');
    try {
      const { tokens } = await fetchAuthSession({ forceRefresh: true });
      if (tokens && tokens.idToken) {
        this.tokenGG = tokens.idToken.toString();
        console.log("✅ Token obtenido correctamente");
        this.tokenReadySubject.next(true);
        return this.tokenGG;
      }
      console.log("❌ No autenticado - no tokens disponibles");
      this.clearToken();
      return "";
    } catch (error: any) {
      console.error("❌ Error al refrescar el token:", error);      
      const invalidSessionErrors = [
        'Refresh Token has been revoked',
        'invalid_grant',
        'No current user',
        'User is not authenticated',
        'NotAuthorizedException',
        'TokenExpiredError',
        'Invalid refresh token',
        'Refresh token expired'
      ];      
      const isInvalidSession = invalidSessionErrors.some(errorMsg => 
        error?.message?.includes(errorMsg)
      );      
      if (isInvalidSession) {
        console.log("🚨 Sesión invalidada detectada, limpiando token...");
        this.clearToken();
      }
      return "";
    }
  }

  getToken(): string {
    return this.tokenGG;
  }

  isTokenReady(): boolean {
    return this.tokenGG !== "" && this.tokenGG !== "valor Inicial";
  }
  clearToken(): void {
    console.log('🧹 Limpiando token...');
    this.tokenGG = "";
    this.tokenReadySubject.next(false);
  }
}
